import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "./quotation.css";
import { useContext } from "react";

import { Container } from "react-bootstrap";
import React, { createContext, useEffect, useState } from "react";
import Navigation from "./Components/StoreManager/Navigation";
import NavigationMobile from "./Components/StoreManager/NavigationMobile";
import { Layout } from "./Components/Layout";
import { Home } from "./Components/StoreManager/Home";
import HomeMobileFront from "./Components/StoreManager/HomeMobileFront";
import CartContext, {
  CartProvider,
} from "./Components/StoreManager/CartContext";
import { Product } from "./Components/StoreManager/Product";
import { Category } from "./Components/StoreManager/Category";
import { OutOfStock } from "./Components/StoreManager/OutOfStock";
import { OrderHistory } from "./Components/StoreManager/OrderHistory";
import { Customers } from "./Components/StoreManager/Customers";
import { Brands } from "./Components/StoreManager/Brands";
import { ProductGroups } from "./Components/StoreManager/ProductGroups";

import { HomeSettingsCarousel } from "./Components/StoreManager/HomeSettingsCarousel";
import { HomeSettingsMainMenu } from "./Components/StoreManager/HomeSettingsMainMenu";
import { HomeSettingsTop5Ads } from "./Components/StoreManager/HomeSettingsTop5Ads";
import UserLogin from "./Components/StoreManager/UserLogin";
import UserChangePassword from "./Components/StoreManager/UserChangePassword";
import Users from "./Components/StoreManager/Users";
import StoreSettings from "./Components/StoreManager/StoreSettings";
import { Coupon } from "./Components/StoreManager/Coupon";
import { ShippingConfig } from "./Components/StoreManager/ShippingConfig";
import { TaxesConfig } from "./Components/StoreManager/TaxesConfig";
import { Themes } from "./Components/StoreManager/Themes";
import { Reports } from "./Components/StoreManager/Reports";
import { ProductThemes } from "./Components/StoreManager/ProductThemes";
import PosUsers from "./Components/StoreManager/PosUsers";
import { RestaurantTables } from "./Components/StoreManager/RestaurantTables";
import TableOrdersQueue from "./Components/StoreManager/TableOrdersQueue";
import Kds from "./Components/StoreManager/Kds";
import Kds2 from "./Components/StoreManager/Kds2";
import { BarCodeCustom } from "./Components/StoreManager/BarCodeCustom";
import { DataTypes } from "./Components/StoreManager/DataTypes";
import { Suppliers } from "./Components/StoreManager/Suppliers";
import { ProductIndent } from "./Components/StoreManager/ProductIndent";
import { ProductInward } from "./Components/StoreManager/ProductInward.js";
import { RawMaterialCategory } from "./Components/StoreManager/RawMaterialCategory";
import { RawMaterialsInventory } from "./Components/StoreManager/RawMaterialInventory";
import { RawMaterialSuppliers } from "./Components/StoreManager/RawMaterialSuppliers";
import { RawMaterialInward } from "./Components/StoreManager/RawMaterialInward";
import { RawMaterialIndent } from "./Components/StoreManager/RawMaterialIndent.js";
import { IngredientsInventory } from "./Components/StoreManager/IngredientsInventory";
import { Recipes } from "./Components/StoreManager/Recipes";
import { ClientCertificate } from "./Components/StoreManager/ClientCertificate";
import { ClientLogo } from "./Components/StoreManager/ClientLogo";
import { ClientTestimonial } from "./Components/StoreManager/ClientTestimonial";
import { ClientDisplayCounter } from "./Components/StoreManager/ClientDisplayCounter";
import { RawMaterialManufacturingRequest } from "./Components/StoreManager/RawMaterialManufacturingRequest";
import { RawMaterialServiceRequest } from "./Components/StoreManager/RawMaterialServiceRequest";

import {
  Orders,
  Package,
  Dispatch,
  Delivery,
  Payment,
  CloseOrder,
  Returns,
} from "./Components/StoreManager/Orders";

import RefreshBearerToken from "./Components/StoreManager/RefreshBearerToken";
import { ManufacturingRequestOrders } from "./Components/StoreManager/ManufacturingRequestOrder";
import { ProductServiceCustomers } from "./Components/StoreManager/ProductServiceCustomers";
import { ProductServiceBookings } from "./Components/StoreManager/ProductServiceBooking";
import { ProductServiceTaskInventory } from "./Components/StoreManager/ProductServiceTaskInventory";
import { ProductServiceRequests } from "./Components/StoreManager/ProductServiceRequests";
import { SalesLeads } from "./Components/StoreManager/SalesLeads";
import { HomeSettingsVlog } from "./Components/StoreManager/HomeSettingsVlog";
import { HomeSettingsBlog } from "./Components/StoreManager/HomeSettingsBlog";
import { LifeStyleAquaAuthenticator } from "./Components/StoreManager/LifeStyleAquaAuthenticator";
import { MultiCurrencys } from "./Components/StoreManager/MultiCurrencyPage";
import { Departments } from "./Components/StoreManager/Departments";
import { Employees } from "./Components/StoreManager/Employees";
import { AccountExpensesCategorys } from "./Components/StoreManager/AccountExpensesCategory";
import { AccountExpenses } from "./Components/StoreManager/AccountExpenses";
import { AccountRevenues } from "./Components/StoreManager/AccountRevenues";
import { AccountReceiveables } from "./Components/StoreManager/AccountReceiveable";
import { AccountPayables } from "./Components/StoreManager/AccountPayable";
import { AccountPayroll } from "./Components/StoreManager/AccountPayroll";
import { AccountLedger } from "./Components/StoreManager/AccountLedger";
import { QuotationRequest } from "./Components/StoreManager/QuotationRequest";
import EmployeeTimesheet from "./Components/StoreManager/EmployeeTimesheet";

import { Row, Col, Button, Offcanvas, Table } from "react-bootstrap";
import { SideMenu } from "./Components/StoreManager/SideMenu";
import { RawMaterialsOutOfStock } from "./Components/StoreManager/RawmaterialsOutOfStock";
import { StorageDrive } from "./Components/StoreManager/StorageDrive";
import { Warehouse } from "./Components/StoreManager/Warehouse";
import EmployeeAbsence from "./Components/StoreManager/EmployeeAbsence.js";
import EmployeeActions from "./Components/StoreManager/EmployeeActions.js";
import EmployeePerformance from "./Components/StoreManager/EmployeePerformance.js";
import EmployeeHolidayCalendar from "./Components/StoreManager/EmployeeHolidayCalender.js";
import EmployeeRequests from "./Components/StoreManager/EmployeeRequests.js";
import ProjectManagement from "./Components/StoreManager/ProjectManagement.js";
import ProjectTasks from "./Components/StoreManager/ProjectTask.js";
import ProjectRisks from "./Components/StoreManager/ProjectRisks.js";
import { ManufacturingTask } from "./Components/StoreManager/ManufacturingTask.js";
import ManufacturingTasks from "./Components/StoreManager/ManufacturingTasks.js";
import RawMaterialsDashboard from "./Components/StoreManager/RawmaterialsDashboard.js";
import RmInventoryDashboard from "./Components/StoreManager/RmInventoryDashboard.js";
import ProductPurchaseDashboard from "./Components/StoreManager/ProductPurchaseDashboard.js";
import ProductInventoryDashboard from "./Components/StoreManager/ProductInventoryDashboard.js";
import { HomeDashboard } from "./Components/StoreManager/HomeDashboard.js";
import OrdersDashboard from "./Components/StoreManager/OrdersDashboard.js";
import SalesLeadDashboard from "./Components/StoreManager/SaleLeadsDashboard.js";
import AccountingDashboard from "./Components/StoreManager/AccountingDashboard.js";
import BankRecoPage from "./Components/StoreManager/BankRecoPage.js";
import BankAccountManagement from "./Components/StoreManager/BankAccountList.js";
import { SalesOrders } from "./Components/StoreManager/SalesOrder.js";
import BulkEmailCampaign from "./Components/StoreManager/BulkEmailCampaign.js";
import { BulkSMSCampaign } from "./Components/StoreManager/BulkSmsCampaign.js";
import { BulkWhatsAppCampaign } from "./Components/StoreManager/BulkWhatsappCampaign.js";
import ProductCatalog from "./Components/StoreManager/ProductCatalog.js";
import { SupplierInventory } from "./Components/StoreManager/SupplierInventory.js";
import SupplierPurchaseOrdersIndent from "./Components/StoreManager/SupplierPurchaseOrdersIndent.js";
import { SupplierPurchaseOrderInward } from "./Components/StoreManager/SupplierPurchaseInward.js";
import SupplierDispatches from "./Components/StoreManager/SupplierDispatches.js";
import SupplierPayments from "./Components/StoreManager/SupplierPayments.js";
import RawMaterialPendingPurchaseItems from "./Components/StoreManager/RawMaterialPendingPurchaseItems.js";
import ProductPendingPurchaseItems from "./Components/StoreManager/ProductPendingPurchaseItems.js";
import HotelRoomStatus from "./Components/Hotel/HotelRoomStatus.js";
import HotelRoomType from "./Components/Hotel/HotelRoomType.js";
import HotelRoom from "./Components/Hotel/HotelRoom.js";
import HotelReservation from "./Components/Hotel/HotelReservation.js";
import HotelFolio from "./Components/Hotel/HotelFolio.js";
import HotelPayment from "./Components/Hotel/HotelPayment.js";
import HotelHousekeepingTask from "./Components/Hotel/HotelHousekeepingTask.js";
import HotelMaintenanceTicket from "./Components/Hotel/HotelMaintenanceTicket.js";
import HotelRatePlan from "./Components/Hotel/HotelRatePlan.js";
import HotelGuestManager from "./Components/Hotel/HotelGuestManager.js";
import HotelBookingCalendar from "./Components/Hotel/HotelBookingCalendar.js";
import ProductSellingPriceRuleManager from "./Components/StoreManager/ProductSellingPriceRuleManager.js";
import LoyaltyPointConfig from "./Components/StoreManager/LoyaltyConfig.js";
import { LedgerBook } from "./Components/StoreManager/AccountLedgerBook.js";
import StorageTankManager from "./Components/StoreManager/StorageTankManager.js";
import LiveFishMovement from "./Components/StoreManager/LiveFishMovement.js";
import CrmDashboard from "./Components/CRM/CrmDashboard";
import CrmContacts from "./Components/CRM/CrmContacts";
import CrmLeads from "./Components/CRM/CrmLeads";
import CrmAppointments from "./Components/CRM/CrmAppointments";
import CrmCases from "./Components/CRM/CrmCases";
import CrmActivities from "./Components/CRM/CrmActivities";
import CrmInvoices from "./Components/CRM/CrmInvoices";
import CrmRoles from "./Components/CRM/CrmRoles";
import CrmUsers from "./Components/CRM/CrmUsers";
import CrmServicePlans from "./Components/CRM/CrmServicePlans";
import CrmTags from "./Components/CRM/CrmTags";

function App() {
  // const { userData } = useContext(CartContext);
  const [showSideBar, setShowSideBar] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);

  const SetLoggedIn = (value) => {
    setLoggedIn(value);
  };

  return (
    <Container fluid className="m-0 p-0 w-100">
      {window.innerWidth <= 900 ? (
        <CartProvider SetLoggedIn={SetLoggedIn}>
          <BrowserRouter>
            <NavigationMobile />
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<HomeMobileFront />} />
                <Route path="HomeMobileFront" element={<HomeMobileFront />} />
                <Route path="home" element={<HomeDashboard />} />
                <Route path="Home" element={<HomeDashboard />} />
                <Route path="HomeDashboard" element={<HomeDashboard />} />
                <Route path="UserLogin" element={<UserLogin />} />
                <Route path="Home" element={<HomeDashboard />} />

                <Route path="Customers" element={<Customers />} />
                <Route path="CrmDashboard" element={<CrmDashboard />} />
                <Route path="CrmContacts" element={<CrmContacts />} />
                <Route path="CrmLeads" element={<CrmLeads />} />
                <Route path="CrmAppointments" element={<CrmAppointments />} />
                <Route path="CrmCases" element={<CrmCases />} />
                <Route path="CrmActivities" element={<CrmActivities />} />
                <Route path="CrmInvoices" element={<CrmInvoices />} />
                <Route path="CrmRoles" element={<CrmRoles />} />
                <Route path="CrmUsers" element={<CrmUsers />} />
                <Route path="CrmServicePlans" element={<CrmServicePlans />} />
                <Route path="CrmTags" element={<CrmTags />} />
                <Route
                  path="Orders"
                  element={<Orders OrderState="Received" />}
                />
                <Route
                  path="Package"
                  element={<Package OrderState="Package" />}
                />
                <Route path="Kds2" element={<Kds2 />} />
                <Route
                  path="Dispatch"
                  element={<Dispatch OrderState="Dispatch" />}
                />
                <Route
                  path="Delivery"
                  element={<Delivery OrderState="Delivery" />}
                />
                <Route
                  path="Payment"
                  element={<Payment OrderState="Payment" />}
                />
                <Route
                  path="CloseOrder"
                  element={<CloseOrder OrderState="Close" />}
                />
                <Route
                  path="OrderHistory"
                  element={<OrderHistory OrderState="History" />}
                />
                <Route
                  path="Returns"
                  element={<Returns OrderState="Returns" />}
                />
                <Route path="TableOrdersQueue" element={<TableOrdersQueue />} />
                <Route path="Product" element={<Product />} />
                <Route path="OutOfStock" element={<OutOfStock />} />
                <Route
                  path="UserChangePassword"
                  element={<UserChangePassword />}
                />

                <Route path="Suppliers" element={<Suppliers />} />
                <Route path="ProductIndent" element={<ProductIndent />} />
                <Route path="ProductInward" element={<ProductInward />} />
                <Route
                  path="LifeStyleAquaAuthenticator"
                  element={<LifeStyleAquaAuthenticator />}
                />
                <Route path="Category" element={<Category />} />
                <Route path="Product" element={<Product />} />
                <Route path="OutOfStock" element={<OutOfStock />} />
                <Route path="ProductGroups" element={<ProductGroups />} />
                <Route path="Brands" element={<Brands />} />
                <Route path="DataTypes" element={<DataTypes />} />

                <Route path="BarCodeCustom" element={<BarCodeCustom />} />
                <Route path="Images" element={<StorageDrive />} />
                <Route
                  path="Orders"
                  element={<Orders OrderState="Received" />}
                />
                <Route path="OrdersDashboard" element={<OrdersDashboard />} />
                <Route
                  path="Package"
                  element={<Package OrderState="Package" />}
                />
                <Route
                  path="Dispatch"
                  element={<Dispatch OrderState="Dispatch" />}
                />
                <Route
                  path="Delivery"
                  element={<Delivery OrderState="Delivery" />}
                />
                <Route
                  path="Payment"
                  element={<Payment OrderState="Payment" />}
                />
                <Route
                  path="CloseOrder"
                  element={<CloseOrder OrderState="Close" />}
                />
                <Route
                  path="OrderHistory"
                  element={<OrderHistory OrderState="History" />}
                />
                <Route
                  path="Returns"
                  element={<Returns OrderState="Returns" />}
                />

                <Route
                  path="HomeSettingsCarousel"
                  element={<HomeSettingsCarousel />}
                />
                <Route path="HomeSettingsVlog" element={<HomeSettingsVlog />} />
                <Route path="HomeSettingsBlog" element={<HomeSettingsBlog />} />

                <Route
                  path="HomeSettingsMainMenu"
                  element={<HomeSettingsMainMenu />}
                />
                <Route
                  path="HomeSettingsTop5Ads"
                  element={<HomeSettingsTop5Ads />}
                />
                <Route
                  path="ClientCertificate"
                  element={<ClientCertificate />}
                />
                <Route path="ClientLogo" element={<ClientLogo />} />
                <Route
                  path="ClientTestimonial"
                  element={<ClientTestimonial />}
                />
                <Route
                  path="ClientDisplayCounter"
                  element={<ClientDisplayCounter />}
                />
                <Route path="Themes" element={<Themes />} />
                <Route path="ProductThemes" element={<ProductThemes />} />
                <Route path="TableOrdersQueue" element={<TableOrdersQueue />} />
                <Route path="Kds" element={<Kds />} />
                <Route path="Kds2" element={<Kds2 />} />

                <Route path="Suppliers" element={<Suppliers />} />
                <Route path="ProductIndent" element={<ProductIndent />} />
                <Route path="ProductInward" element={<ProductInward />} />
                <Route
                  path="ProductPurchaseDashboard"
                  element={<ProductPurchaseDashboard />}
                />
                <Route
                  path="ProductInventoryDashboard"
                  element={<ProductInventoryDashboard />}
                />

                <Route path="Customers" element={<Customers />} />
                <Route path="Coupon" element={<Coupon />} />

                {/* Admin */}

                <Route path="Users" element={<Users />} />

                <Route path="ShippingConfig" element={<ShippingConfig />} />
                <Route path="TaxesConfig" element={<TaxesConfig />} />
                <Route path="RestaurantTables" element={<RestaurantTables />} />

                <Route path="StoreSettings" element={<StoreSettings />} />
                <Route
                  path="UserChangePassword"
                  element={<UserChangePassword />}
                />
                <Route path="PosUsers" element={<PosUsers />} />
                <Route path="Reports" element={<Reports />} />

                <Route
                  path="ManufacturingRequestOrders"
                  element={<ManufacturingRequestOrders />}
                />
                <Route
                  path="ManufacturingTasks"
                  element={<ManufacturingTasks />}
                />
                {/* RawMaterial */}
                <Route
                  path="RawMaterialCategory"
                  element={<RawMaterialCategory />}
                />
                <Route path="Warehouse" element={<Warehouse />} />
                <Route
                  path="RawMaterialsInventory"
                  element={<RawMaterialsInventory />}
                />
                <Route
                  path="RmInventoryDashboard"
                  element={<RmInventoryDashboard />}
                />

                <Route
                  path="RawMaterialsOutOfStock"
                  element={<RawMaterialsOutOfStock />}
                />
                <Route
                  path="RawMaterialsDashboard"
                  element={<RawMaterialsDashboard />}
                />

                <Route
                  path="RawMaterialSuppliers"
                  element={<RawMaterialSuppliers />}
                />
                <Route
                  path="RawMaterialInward"
                  element={<RawMaterialInward />}
                />
                <Route
                  path="RawMaterialIndent"
                  element={<RawMaterialIndent />}
                />
                <Route
                  path="RawMaterialManufacturingRequest"
                  element={<RawMaterialManufacturingRequest />}
                />
                <Route
                  path="RawMaterialServiceRequest"
                  element={<RawMaterialServiceRequest />}
                />

                <Route
                  path="IngredientsInventory"
                  element={<IngredientsInventory />}
                />
                <Route path="Recipes" element={<Recipes />} />
                <Route
                  path="ProductServiceCustomers"
                  element={<ProductServiceCustomers />}
                />
                <Route
                  path="ProductServiceBookings"
                  element={<ProductServiceBookings />}
                />
                <Route
                  path="ProductServiceTaskInventory"
                  element={<ProductServiceTaskInventory />}
                />
                <Route
                  path="ProductServiceRequests"
                  element={<ProductServiceRequests />}
                />
                <Route path="SalesLeads" element={<SalesLeads />} />
                <Route path="SalesOrders" element={<SalesOrders />} />
                <Route
                  path="SalesLeadDashboard"
                  element={<SalesLeadDashboard />}
                />

                <Route
                  path="LifeStyleAquaAuthenticator"
                  element={<LifeStyleAquaAuthenticator />}
                />
                <Route path="MultiCurrencys" element={<MultiCurrencys />} />
                <Route path="Departments" element={<Departments />} />
                <Route path="Employees" element={<Employees />} />
                <Route
                  path="EmployeeTimesheet"
                  element={<EmployeeTimesheet />}
                />
                <Route path="EmployeeAbsence" element={<EmployeeAbsence />} />
                <Route
                  path="EmployeePerformance"
                  element={<EmployeePerformance />}
                />
                <Route
                  path="EmployeeHolidayCalendar"
                  element={<EmployeeHolidayCalendar />}
                />

                <Route path="EmployeeActions" element={<EmployeeActions />} />
                <Route path="EmployeeRequests" element={<EmployeeRequests />} />
                <Route path="ProjectTasks" element={<ProjectTasks />} />
                <Route path="ProjectRisks" element={<ProjectRisks />} />

                <Route
                  path="ProjectManagement"
                  element={<ProjectManagement />}
                />

                <Route
                  path="AccountExpensesCategorys"
                  element={<AccountExpensesCategorys />}
                />

                <Route path="AccountExpenses" element={<AccountExpenses />} />
                <Route path="AccountRevenues" element={<AccountRevenues />} />
                <Route
                  path="AccountReceiveables"
                  element={<AccountReceiveables />}
                />
                <Route path="AccountPayables" element={<AccountPayables />} />
                <Route path="AccountPayroll" element={<AccountPayroll />} />
                <Route path="AccountLedger" element={<AccountLedger />} />
                <Route
                  path="BankAccountManagement"
                  element={<BankAccountManagement />}
                />
                <Route path="BankRecoPage" element={<BankRecoPage />} />
                <Route
                  path="AccountingDashboard"
                  element={<AccountingDashboard />}
                />

                <Route path="QuotationRequest" element={<QuotationRequest />} />
                <Route
                  path="BulkEmailCampaign"
                  element={<BulkEmailCampaign />}
                />
                <Route path="BulkSMSCampaign" element={<BulkSMSCampaign />} />
                <Route
                  path="BulkWhatsAppCampaign"
                  element={<BulkWhatsAppCampaign />}
                />

                <Route path="Reports" element={<Reports />} />

                <Route
                  path="SupplierInventory"
                  element={<SupplierInventory />}
                />
                <Route
                  path="SupplierPurchaseOrdersIndent"
                  element={<SupplierPurchaseOrdersIndent />}
                />
                <Route
                  path="SupplierPurchaseOrderInward"
                  element={<SupplierPurchaseOrderInward />}
                />

                <Route path="*" element={<HomeMobileFront />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
      ) : (
        <CartProvider SetLoggedIn={SetLoggedIn}>
          <BrowserRouter>
            <Navigation></Navigation>
            {/* <Routes>
              <Route path="UserLogin" element={<UserLogin />} />
            </Routes> */}
            <div
              className="Container-fluid mx-0 px-0"
              style={{
                backgroundImage: `background-image: url("data:image/svg+xml,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='40' height='40' patternTransform='scale(2) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,100%,1)'/><path d='M40 45a5 5 0 110-10 5 5 0 010 10zM0 45a5 5 0 110-10 5 5 0 010 10zM0 5A5 5 0 110-5 5 5 0 010 5zm40 0a5 5 0 110-10 5 5 0 010 10z'  stroke-width='1' stroke='hsla(153, 98%, 48%, 1)' fill='none'/><path d='M20 25a5 5 0 110-10 5 5 0 010 10z'  stroke-width='1' stroke='hsla(175, 98%, 48%, 1)' fill='none'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>")`,
              }}
            >
              <Row>
                {showSideBar == true && loggedIn == true ? (
                  <>
                    <Col xs="2" className="bg-light m-0 p-0">
                      <SideMenu showSideBar={setShowSideBar}></SideMenu>
                    </Col>
                  </>
                ) : (
                  <></>
                )}

                <Col
                  xs={showSideBar == true && loggedIn == true ? "10" : "12"}
                  className=" m-0 px-1"
                >
                  <Table>
                    <tbody>
                      {showSideBar == false ? (
                        <>
                          <td
                            width="3%"
                            className="bg-black fixedTableHightOrder"
                            style={{
                              minHeight: window.innerHeight + "px",
                            }}
                          >
                            <div className="text-start">
                              <Button
                                variant="dark"
                                className="rounded-circle"
                                onClick={(e) => setShowSideBar(true)}
                              >
                                &gt;&gt;
                              </Button>
                            </div>
                          </td>
                        </>
                      ) : (
                        <></>
                      )}

                      <td width={showSideBar == false ? "97%" : "100%"}>
                        <Routes>
                          <Route path="/" element={<Layout />}>
                            <Route index element={<Home />} />
                            <Route
                              path="UserLogin"
                              element={<UserLogin loggedIn={SetLoggedIn} />}
                            />
                            <Route path="home" element={<Home />} />
                            <Route path="Home" element={<Home />} />
                            <Route
                              path="HomeDashboard"
                              element={<HomeDashboard />}
                            />
                            <Route path="Category" element={<Category />} />
                            <Route
                              path="ProductSellingPriceRuleManager"
                              element={<ProductSellingPriceRuleManager />}
                            />
                            <Route path="Product" element={<Product />} />
                            <Route path="OutOfStock" element={<OutOfStock />} />
                            <Route
                              path="ProductGroups"
                              element={<ProductGroups />}
                            />
                            <Route path="Brands" element={<Brands />} />
                            <Route path="DataTypes" element={<DataTypes />} />
                            <Route
                              path="StorageTankManager"
                              element={<StorageTankManager />}
                            />
                            <Route
                              path="LiveFishMovement"
                              element={<LiveFishMovement />}
                            />
                            <Route
                              path="BarCodeCustom"
                              element={<BarCodeCustom />}
                            />
                            <Route path="Images" element={<StorageDrive />} />
                            <Route
                              path="Orders"
                              element={<Orders OrderState="Received" />}
                            />
                            <Route
                              path="OrdersDashboard"
                              element={<OrdersDashboard />}
                            />
                            <Route
                              path="Package"
                              element={<Package OrderState="Package" />}
                            />
                            <Route
                              path="Dispatch"
                              element={<Dispatch OrderState="Dispatch" />}
                            />
                            <Route
                              path="Delivery"
                              element={<Delivery OrderState="Delivery" />}
                            />
                            <Route
                              path="Payment"
                              element={<Payment OrderState="Payment" />}
                            />
                            <Route
                              path="CloseOrder"
                              element={<CloseOrder OrderState="Close" />}
                            />
                            <Route
                              path="OrderHistory"
                              element={<OrderHistory OrderState="History" />}
                            />
                            <Route
                              path="Returns"
                              element={<Returns OrderState="Returns" />}
                            />

                            <Route
                              path="HomeSettingsCarousel"
                              element={<HomeSettingsCarousel />}
                            />
                            <Route
                              path="HomeSettingsVlog"
                              element={<HomeSettingsVlog />}
                            />
                            <Route
                              path="HomeSettingsBlog"
                              element={<HomeSettingsBlog />}
                            />

                            <Route
                              path="HomeSettingsMainMenu"
                              element={<HomeSettingsMainMenu />}
                            />
                            <Route
                              path="HomeSettingsTop5Ads"
                              element={<HomeSettingsTop5Ads />}
                            />
                            <Route
                              path="ClientCertificate"
                              element={<ClientCertificate />}
                            />
                            <Route path="ClientLogo" element={<ClientLogo />} />
                            <Route
                              path="ClientTestimonial"
                              element={<ClientTestimonial />}
                            />
                            <Route
                              path="ClientDisplayCounter"
                              element={<ClientDisplayCounter />}
                            />
                            <Route path="Themes" element={<Themes />} />
                            <Route
                              path="ProductThemes"
                              element={<ProductThemes />}
                            />
                            <Route
                              path="TableOrdersQueue"
                              element={<TableOrdersQueue />}
                            />
                            <Route path="Kds" element={<Kds />} />
                            <Route path="Kds2" element={<Kds2 />} />

                            <Route path="Suppliers" element={<Suppliers />} />
                            <Route
                              path="ProductIndent"
                              element={<ProductIndent />}
                            />
                            <Route
                              path="ProductInward"
                              element={<ProductInward />}
                            />
                            <Route
                              path="ProductPurchaseDashboard"
                              element={<ProductPurchaseDashboard />}
                            />
                            <Route
                              path="ProductInventoryDashboard"
                              element={<ProductInventoryDashboard />}
                            />

                            <Route path="Customers" element={<Customers />} />
                            <Route path="Coupon" element={<Coupon />} />

                            {/* Admin */}

                            <Route path="Users" element={<Users />} />

                            <Route
                              path="ShippingConfig"
                              element={<ShippingConfig />}
                            />
                            <Route
                              path="TaxesConfig"
                              element={<TaxesConfig />}
                            />
                            <Route
                              path="RestaurantTables"
                              element={<RestaurantTables />}
                            />

                            <Route
                              path="StoreSettings"
                              element={<StoreSettings />}
                            />
                            <Route
                              path="UserChangePassword"
                              element={<UserChangePassword />}
                            />
                            <Route path="PosUsers" element={<PosUsers />} />
                            <Route
                              path="LoyaltyPointConfig"
                              element={<LoyaltyPointConfig />}
                            />

                            <Route path="Reports" element={<Reports />} />

                            <Route
                              path="ManufacturingRequestOrders"
                              element={<ManufacturingRequestOrders />}
                            />
                            <Route
                              path="ManufacturingTasks"
                              element={<ManufacturingTasks />}
                            />
                            {/* RawMaterial */}
                            <Route
                              path="RawMaterialCategory"
                              element={<RawMaterialCategory />}
                            />
                            <Route path="Warehouse" element={<Warehouse />} />
                            <Route
                              path="RawMaterialsInventory"
                              element={<RawMaterialsInventory />}
                            />
                            <Route
                              path="RmInventoryDashboard"
                              element={<RmInventoryDashboard />}
                            />

                            <Route
                              path="RawMaterialsOutOfStock"
                              element={<RawMaterialsOutOfStock />}
                            />
                            <Route
                              path="RawMaterialsDashboard"
                              element={<RawMaterialsDashboard />}
                            />

                            <Route
                              path="RawMaterialSuppliers"
                              element={<RawMaterialSuppliers />}
                            />
                            <Route
                              path="RawMaterialInward"
                              element={<RawMaterialInward />}
                            />
                            <Route
                              path="RawMaterialIndent"
                              element={<RawMaterialIndent />}
                            />
                            <Route
                              path="RawMaterialManufacturingRequest"
                              element={<RawMaterialManufacturingRequest />}
                            />
                            <Route
                              path="RawMaterialServiceRequest"
                              element={<RawMaterialServiceRequest />}
                            />

                            <Route
                              path="IngredientsInventory"
                              element={<IngredientsInventory />}
                            />
                            <Route path="Recipes" element={<Recipes />} />
                            <Route
                              path="ProductServiceCustomers"
                              element={<ProductServiceCustomers />}
                            />
                            <Route
                              path="ProductServiceBookings"
                              element={<ProductServiceBookings />}
                            />
                            <Route
                              path="ProductServiceTaskInventory"
                              element={<ProductServiceTaskInventory />}
                            />
                            <Route
                              path="ProductServiceRequests"
                              element={<ProductServiceRequests />}
                            />
                            <Route path="SalesLeads" element={<SalesLeads />} />
                            <Route
                              path="SalesOrders"
                              element={<SalesOrders />}
                            />
                            <Route
                              path="SalesLeadDashboard"
                              element={<SalesLeadDashboard />}
                            />
                            <Route
                              path="CrmDashboard"
                              element={<CrmDashboard />}
                            />
                            <Route
                              path="CrmContacts"
                              element={<CrmContacts />}
                            />
                            <Route path="CrmLeads" element={<CrmLeads />} />
                            <Route
                              path="CrmAppointments"
                              element={<CrmAppointments />}
                            />
                            <Route path="CrmCases" element={<CrmCases />} />
                            <Route
                              path="CrmActivities"
                              element={<CrmActivities />}
                            />
                            <Route
                              path="CrmInvoices"
                              element={<CrmInvoices />}
                            />
                            <Route path="CrmRoles" element={<CrmRoles />} />
                            <Route path="CrmUsers" element={<CrmUsers />} />
                            <Route
                              path="CrmServicePlans"
                              element={<CrmServicePlans />}
                            />
                            <Route path="CrmTags" element={<CrmTags />} />

                            <Route
                              path="LifeStyleAquaAuthenticator"
                              element={<LifeStyleAquaAuthenticator />}
                            />
                            <Route
                              path="MultiCurrencys"
                              element={<MultiCurrencys />}
                            />
                            <Route
                              path="Departments"
                              element={<Departments />}
                            />
                            <Route path="Employees" element={<Employees />} />
                            <Route
                              path="EmployeeTimesheet"
                              element={<EmployeeTimesheet />}
                            />
                            <Route
                              path="EmployeeAbsence"
                              element={<EmployeeAbsence />}
                            />
                            <Route
                              path="EmployeePerformance"
                              element={<EmployeePerformance />}
                            />
                            <Route
                              path="EmployeeHolidayCalendar"
                              element={<EmployeeHolidayCalendar />}
                            />

                            <Route
                              path="EmployeeActions"
                              element={<EmployeeActions />}
                            />
                            <Route
                              path="EmployeeRequests"
                              element={<EmployeeRequests />}
                            />
                            <Route
                              path="ProjectTasks"
                              element={<ProjectTasks />}
                            />
                            <Route
                              path="ProjectRisks"
                              element={<ProjectRisks />}
                            />

                            <Route
                              path="ProjectManagement"
                              element={<ProjectManagement />}
                            />

                            <Route
                              path="AccountExpensesCategorys"
                              element={<AccountExpensesCategorys />}
                            />

                            <Route
                              path="AccountExpenses"
                              element={<AccountExpenses />}
                            />
                            <Route
                              path="AccountRevenues"
                              element={<AccountRevenues />}
                            />
                            <Route
                              path="AccountReceiveables"
                              element={<AccountReceiveables />}
                            />
                            <Route
                              path="AccountPayables"
                              element={<AccountPayables />}
                            />
                            <Route
                              path="AccountPayroll"
                              element={<AccountPayroll />}
                            />
                            <Route
                              path="AccountLedger"
                              element={<AccountLedger />}
                            />
                            <Route path="LedgerBook" element={<LedgerBook />} />
                            <Route
                              path="BankAccountManagement"
                              element={<BankAccountManagement />}
                            />
                            <Route
                              path="BankRecoPage"
                              element={<BankRecoPage />}
                            />
                            <Route
                              path="AccountingDashboard"
                              element={<AccountingDashboard />}
                            />

                            <Route
                              path="QuotationRequest"
                              element={<QuotationRequest />}
                            />
                            <Route
                              path="BulkEmailCampaign"
                              element={<BulkEmailCampaign />}
                            />
                            <Route
                              path="BulkSMSCampaign"
                              element={<BulkSMSCampaign />}
                            />
                            <Route
                              path="BulkWhatsAppCampaign"
                              element={<BulkWhatsAppCampaign />}
                            />
                            <Route
                              path="ProductCatalog"
                              element={<ProductCatalog />}
                            />

                            <Route
                              path="SupplierInventory"
                              element={<SupplierInventory />}
                            />
                            <Route
                              path="SupplierPurchaseOrdersIndent"
                              element={<SupplierPurchaseOrdersIndent />}
                            />
                            <Route
                              path="SupplierPurchaseOrderInward"
                              element={<SupplierPurchaseOrderInward />}
                            />
                            <Route
                              path="SupplierDispatches"
                              element={<SupplierDispatches />}
                            />
                            <Route
                              path="SupplierPayments"
                              element={<SupplierPayments />}
                            />
                            <Route
                              path="RawMaterialPendingPurchaseItems"
                              element={<RawMaterialPendingPurchaseItems />}
                            />
                            <Route
                              path="ProductPendingPurchaseItems"
                              element={<ProductPendingPurchaseItems />}
                            />

                            <Route
                              path="HotelRoomStatus"
                              element={<HotelRoomStatus />}
                            />
                            <Route
                              path="HotelRoomTypes"
                              element={<HotelRoomType />}
                            />
                            <Route path="HotelRoom" element={<HotelRoom />} />
                            <Route
                              path="HotelReservation"
                              element={<HotelReservation />}
                            />
                            <Route
                              path="HotelBookingCalendar"
                              element={<HotelBookingCalendar />}
                            />
                            <Route path="HotelFolio" element={<HotelFolio />} />

                            <Route
                              path="HotelPayment"
                              element={<HotelPayment />}
                            />
                            <Route
                              path="HotelHousekeepingTask"
                              element={<HotelHousekeepingTask />}
                            />
                            <Route
                              path="HotelMaintenanceTicket"
                              element={<HotelMaintenanceTicket />}
                            />
                            <Route
                              path="HotelRatePlan"
                              element={<HotelRatePlan />}
                            />
                            <Route
                              path="HotelGuestManager"
                              element={<HotelGuestManager />}
                            />

                            <Route
                              path="*"
                              element={<UserLogin loggedIn={SetLoggedIn} />}
                            />
                          </Route>
                        </Routes>
                      </td>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </div>
          </BrowserRouter>
        </CartProvider>
      )}
    </Container>
  );
}

export default App;
